<footer class="mainFooter c7-app-footer">
  <div class="mainFooter__inner">
    <span class="mainFooter__text">CULTURA™ - © {{ currentYear }} Nynos GmbH - All rights reserved</span>
    <nav class="mainFooter__links" [attr.aria-label]="'legalPages.footerNav' | translate">
      <a routerLink="/imprint">{{ "legalPages.imprint" | translate }}</a>
      <a routerLink="/privacy">{{ "legalPages.privacy" | translate }}</a>
      <a routerLink="/terms">{{ "legalPages.terms" | translate }}</a>
    </nav>
  </div>
</footer>
